export interface LanguagesLabels {
  hi: LanguagesLabel;
  en: LanguagesLabel;
  mr: LanguagesLabel;
  te: LanguagesLabel;
  kn: LanguagesLabel;
  ta: LanguagesLabel;
  ml: LanguagesLabel;
  bn: LanguagesLabel;
  gu: LanguagesLabel;
  pa: LanguagesLabel;
  hr: LanguagesLabel;
  Silent: LanguagesLabel;
  th: LanguagesLabel;
  id: LanguagesLabel;
  ms: LanguagesLabel;
  de: LanguagesLabel;
  ru: LanguagesLabel;
  ar: LanguagesLabel;
}

export interface LanguagesLabel {
  hi: string;
  en: string;
  mr: string;
  te: string;
  kn: string;
  ta: string;
  ml: string;
  bn: string;
  gu: string;
  pa: string;
  hr: string;
  or: string;
  ur: string;
  th: string;
  id: string;
  ms: string;
  de: string;
  ru: string;
  ar: string;
  Silent: 'Silent';
}

export const LANGUAGE_LABELS: LanguagesLabels = {
  hi: {
    hi: 'हिंदी',
    en: 'अंग्रेज़ी',
    mr: 'मराठी',
    te: 'तेलुगू',
    kn: 'कन्नड़',
    ta: 'तामिल',
    ml: 'मलयालम',
    bn: 'बंगाली',
    gu: 'गुजराती',
    pa: 'पंजाबी',
    hr: 'भोजपुरी',
    or: 'ओरिया',
    ur: 'उर्दू',
    th: 'थाई',
    id: 'वियतनामी',
    ms: 'मलायी',
    de: 'जर्मन',
    ru: 'रूसी',
    ar: 'अरबी',
    Silent: 'Silent'
  },
  en: {
    hi: 'Hindi',
    en: 'English',
    mr: 'Marathi',
    te: 'Telugu',
    kn: 'Kannada',
    ta: 'Tamil',
    ml: 'Malayalam',
    bn: 'Bengali',
    gu: 'Gujarati',
    pa: 'Punjabi',
    hr: 'Bhojpuri',
    or: 'Odia',
    ur: 'Urdu',
    th: 'Thai',
    id: 'Indonesian',
    ms: 'Malay',
    de: 'German',
    ru: 'Russian',
    ar: 'Arabic',
    Silent: 'Silent'
  },
  mr: {
    hi: 'हिंदी',
    en: 'इंग्रजी',
    mr: 'मराठी',
    te: 'तेलगू',
    kn: 'कन्नड',
    ta: 'तामिळ',
    ml: 'मल्याळम',
    bn: 'बंगाली',
    gu: 'गुजराती',
    pa: 'पंजाबी',
    hr: 'भोजपुरी',
    or: 'ओरिआ',
    ur: 'उर्दू',
    th: 'थाई',
    id: 'व्हिएतनामी',
    ms: 'मलय',
    de: 'जर्मन',
    ru: 'रूसी',
    ar: 'अरबी',
    Silent: 'Silent'
  },
  te: {
    hi: 'హిందీ',
    en: 'ఇంగ్లీష్',
    mr: 'మరాఠీ',
    te: 'తెలుగు',
    kn: 'కన్నడ',
    ta: 'తమిళ',
    ml: 'మలయాళం',
    bn: 'బెంగాలీ',
    gu: 'గుజరాతి',
    pa: 'పంజాబీ',
    hr: 'భోజ్ పూరి',
    or: 'ఒరియా',
    ur: 'ఉర్దు',
    th: 'థాయ్',
    id: 'ఇండోనేషియన్',
    ms: 'Malay',
    de: 'జర్మన్',
    ru: 'రష్యన్',
    ar: 'అరబిక్',
    Silent: 'Silent'
  },
  kn: {
    hi: 'ಹಿಂದಿ',
    en: 'ಇಂಗ್ಲಿಷ್',
    mr: 'ಮರಾಠಿ',
    te: 'ತೆಲುಗು',
    kn: 'ಕನ್ನಡ',
    ta: 'ತಮಿಳು',
    ml: 'ಮಲಯಾಳಂ',
    bn: 'ಬೆಂಗಾಲಿ',
    gu: 'ಗುಜರಾತಿ',
    pa: 'ಪಂಜಾಬಿ',
    hr: 'ಭೋಜ್ಪುರಿ',
    or: 'ಓರಿಯಾ',
    ur: 'ಉರ್ದು',
    th: 'ಥಾಯ್',
    id: 'ಇಂಡೋನೇಷಿಯನ್',
    ms: 'ಮಲಯ',
    de: 'ಜರ್ಮನ್',
    ru: 'ರಷ್ಯನ್',
    ar: 'ಅರಬ್ಬೀ',
    Silent: 'Silent'
  },
  ta: {
    hi: 'இந்தி',
    en: 'ஆங்கிலம்',
    mr: 'மராத்தி',
    te: 'தெலுங்கு',
    kn: 'கன்னடம்',
    ta: 'தமிழ்',
    ml: 'மலையாளம்',
    bn: 'பெங்காலி',
    gu: 'குஜராத்தி',
    pa: 'பஞ்சாபி',
    hr: 'போஜ்புரி',
    or: 'ஒரியா',
    ur: 'உருது',
    th: 'தாய்லாந்து மொழி',
    id: 'இந்தோனேஷியன்',
    ms: 'மலாய்',
    de: 'ஜெர்மன்',
    ru: 'ரஷியன்',
    ar: 'அரபிக்',
    Silent: 'Silent'
  },
  ml: {
    hi: 'ഹിന്ദി',
    en: 'ഇംഗ്ലീഷ്',
    mr: 'മറാത്തി',
    te: 'തെലുങ്ക്',
    kn: 'കന്നഡ',
    ta: 'തമിഴ്',
    ml: 'മലയാളം',
    bn: 'ബംഗാളി',
    gu: 'ഗുജറാത്തി',
    pa: 'പഞ്ചാബി',
    hr: 'ഭോജ്പുരി',
    or: 'ഓറിയ',
    ur: 'ഉറുദു',
    th: 'തായ്',
    id: 'ഇന്തോനേഷ്യൻ',
    ms: 'മലായ്',
    de: 'ജർമ്മൻ',
    ru: 'റഷ്യൻ',
    ar: 'അറബി',
    Silent: 'Silent'
  },
  bn: {
    hi: 'হিন্দি',
    en: 'ইংরেজি',
    mr: 'মারাঠি',
    te: 'তেলুগু',
    kn: 'কন্নড',
    ta: 'তামিল',
    ml: 'মালায়ালম',
    bn: 'বাঙালি',
    gu: 'গুজরাটি',
    pa: 'পাঞ্জাবি',
    hr: 'ভোজপুরী',
    or: 'ওড়িয়া',
    ur: 'উর্দু',
    th: 'থাই',
    id: 'ইন্দোনেশিয়াসম্বন্ধীয়',
    ms: 'মালে',
    de: 'জার্মান',
    ru: 'রাশিয়ান',
    ar: 'আরবিক',
    Silent: 'Silent'
  },
  gu: {
    hi: 'હિન્દી',
    en: 'અંગ્રેજી',
    mr: 'મરાઠી',
    te: 'તેલુગુ',
    kn: 'કન્નડ',
    ta: 'તમિલ',
    ml: 'મલયાલમ',
    bn: 'બંગાળી',
    gu: 'ગુજરાતી',
    pa: 'પંજાબી',
    hr: 'ભોજપુરી',
    or: 'ઓરિયા',
    ur: 'ઉર્દુ',
    th: 'થાઇ',
    id: 'ઇન્ડોનેશિયન',
    ms: 'મલય',
    de: 'જર્મન',
    ru: 'રશિયન',
    ar: 'અરબી',
    Silent: 'Silent'
  },
  pa: {
    hi: 'ਹਿੰਦੀ',
    en: 'ਅੰਗਰੇਜ਼ੀ',
    mr: 'ਮਰਾਠੀ',
    te: 'ਤੇਲਗੂ',
    kn: 'ਕੰਨੜ',
    ta: 'ਤਾਮਿਲ',
    ml: 'ਮਲੇਲੀਆਮ',
    bn: 'ਬੰਗਾਲੀ',
    gu: 'ਗੁਜਰਾਤੀ',
    pa: 'ਪੰਜਾਬੀ',
    hr: 'ਭੋਜਪੁਰੀ',
    or: 'ਔਰਿਆ',
    ur: 'ਉਰਦੂ',
    th: 'ਥਾਈ',
    id: 'ਇੰਡੋਨੇਸ਼ੀਆਈ',
    ms: 'ਮਲਾ',
    de: 'ਜਰਮਨ',
    ru: 'ਰੂਸੀ',
    ar: 'ਅਰਬੀ',
    Silent: 'Silent'
  },
  hr: {
    hi: 'हिंदी',
    en: 'अंग्रेज़ी',
    mr: 'मराठी',
    te: 'तेलुगू',
    kn: 'कन्नड़',
    ta: 'तामिल',
    ml: 'मलयालम',
    bn: 'बंगाली',
    gu: 'गुजराती',
    pa: 'पंजाबी',
    hr: 'भोजपुरी',
    or: 'ओरिआ',
    ur: 'उर्दू',
    th: 'थाई',
    id: 'इन्डोनेशियाई',
    ms: 'मलायी',
    de: 'जर्मन',
    ru: 'रूसी',
    ar: 'अरबी',
    Silent: 'Silent'
  },
  Silent: {
    hi: 'Silent',
    en: 'Silent',
    mr: 'Silent',
    te: 'Silent',
    kn: 'Silent',
    ta: 'Silent',
    ml: 'Silent',
    bn: 'Silent',
    gu: 'Silent',
    pa: 'Silent',
    hr: 'Silent',
    or: 'Silent',
    ur: 'Silent',
    th: 'Thai',
    id: 'Indonesian',
    ms: 'Malay',
    de: 'German',
    ru: 'Russian',
    ar: 'Arabic',
    Silent: 'Silent'
  },
  th: {
    hi: 'ภาษาฮินดี',
    en: 'อังกฤษ',
    mr: 'ฐี',
    te: 'กู',
    kn: 'ดา',
    ta: 'มิลักขะ',
    ml: 'มาลายาลัม',
    bn: 'ประเทศบังคลาเทศ',
    gu: 'คุชราต',
    pa: 'ปัญจาบ',
    hr: 'โบชปูรี',
    or: 'โอริยา',
    ur: 'ภาษาอูรดู',
    th: 'ไทย',
    id: 'ชาวอินโดนีเซีย',
    ms: 'ภาษามลายู',
    de: 'เยอรมัน',
    ru: 'รัสเซีย',
    ar: 'อารบิก',
    Silent: 'Silent'
  },
  id: {
    hi: 'Hindi',
    en: 'Inggris',
    mr: 'Marathi',
    te: 'Telugu',
    kn: 'Kannada',
    ta: 'Tamil',
    ml: 'Malayalam',
    bn: 'Benggala',
    gu: 'Gujarati',
    pa: 'Punjabi',
    hr: 'Bhojpuri',
    or: 'Odia',
    ur: 'Urdu',
    th: 'Thai',
    id: 'bahasa Indonesia',
    ms: 'Melayu',
    de: 'Jerman',
    ru: 'Rusia',
    ar: 'Arab',
    Silent: 'Silent'
  },
  ms: {
    hi: 'Hindi',
    en: 'Bahasa Inggeris',
    mr: 'Marathi',
    te: 'Telugu',
    kn: 'Kannada',
    ta: 'Tamil',
    ml: 'Malayalam',
    bn: 'Bengali',
    gu: 'Gujarati',
    pa: 'Punjabi',
    hr: 'Bhojpuri',
    or: 'Odia',
    ur: 'Urdu',
    th: 'Thai',
    id: 'Bahasa Indonesia',
    ms: 'Melayu',
    de: 'Jerman',
    ru: 'Rusia',
    ar: 'Bahasa Arab',
    Silent: 'Silent'
  },
  de: {
    hi: 'Hindi',
    en: 'Englisch',
    mr: 'Marathi',
    te: 'Telugu',
    kn: 'Kannada',
    ta: 'Tamilisch',
    ml: 'Malayalam',
    bn: 'Bengali',
    gu: 'Gujarati',
    pa: 'Punjabi',
    hr: 'Bhojpuri',
    or: 'Odia',
    ur: 'Urdu',
    th: 'Thai',
    id: 'Indonesisch',
    ms: 'malaiisch',
    de: 'Deutsch',
    ru: 'Russisch',
    ar: 'Arabisch',
    Silent: 'Silent'
  },
  ru: {
    hi: 'хинди',
    en: 'Английский',
    mr: 'маратхи',
    te: 'телугу',
    kn: 'каннада',
    ta: 'тамильский',
    ml: 'Малаялам',
    bn: 'бенгальский',
    gu: 'гуджарати',
    pa: 'панджаби',
    hr: 'бходжпури',
    or: 'Ория',
    ur: 'Урду',
    th: 'тайский',
    id: 'индонезийский',
    ms: 'малайский',
    de: 'Немецкий',
    ru: 'русский',
    ar: 'арабский',
    Silent: 'Silent'
  },
  ar: {
    hi: 'Hindi',
    en: 'English',
    mr: 'Marathi',
    te: 'Telugu',
    kn: 'Kannada',
    ta: 'Tamil',
    ml: 'Malayalam',
    bn: 'Bengali',
    gu: 'Gujarati',
    pa: 'Punjabi',
    hr: 'Bhojpuri',
    or: 'Odia',
    ur: 'الأردية',
    th: 'Thai',
    id: 'Bahasa Indonesia',
    ms: 'Malay',
    de: 'German',
    ru: 'Russian',
    ar: 'ربى',
    Silent: 'Silent'
  }
};
